import { FormDesignTable } from "components/Tables/FormDesignTable/FormDesignTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolDesignHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/")({
    component: FormDesignPage,
    staticData: {
        permissions: [PermissionEnum.ToolDesignForm],
        showInSideMenu: false,
        label: "pages.tool.design.form.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.design.form.title"),
        };
    },
});

function FormDesignPage() {
    return (
        <TenantPage headerNavigationItems={getToolDesignHeaderItems}>
            <FormDesignTable />
        </TenantPage>
    );
}
